import styled from "styled-components";

export const StyledContainer = styled.div`
  height: 100%;
  padding: 0 15px;
  display: flex;
  align-items: center;
  font-size: 0;
  max-width: 100%;
`;
